<div class="contact-container">
  <div class="contact-header">
    <h2>تماس با ما</h2>
    <!-- <p> با ما در تماس باشید.</p> -->
  </div>

  <form [formGroup]="contactForm" (ngSubmit)="onSubmit()" novalidate>
    <div class="form-group">
      <label for="name">نام:</label>
      <input
        type="text"
        id="name"
        formControlName="name"
        [class.is-invalid]="formControls['name'].invalid && (formControls['name'].touched || formControls['name'].dirty)"
      />
      <div *ngIf="formControls['name'].invalid && (formControls['name'].touched || formControls['name'].dirty)" class="error-message">
        <div *ngIf="formControls['name'].errors?.['required']">نام الزامی است.</div>
        <div *ngIf="formControls['name'].errors?.['maxlength']">نام نباید بیشتر از ۱۰۰ کاراکتر باشد.</div>
        <!-- خطای سرور برای نام -->
        <div *ngIf="formControls['name'].errors?.['serverError']">{{ formControls['name'].errors?.['serverError'] }}</div>
      </div>
    </div>

    <div class="form-group">
      <label for="email">ایمیل:</label>
      <input
        type="email"
        id="email"
        formControlName="email"
        [class.is-invalid]="formControls['email'].invalid && (formControls['email'].touched || formControls['email'].dirty)"
      />
      <div *ngIf="formControls['email'].invalid && (formControls['email'].touched || formControls['email'].dirty)" class="error-message">
        <div *ngIf="formControls['email'].errors?.['required']">ایمیل الزامی است.</div>
        <div *ngIf="formControls['email'].errors?.['email']">فرمت ایمیل نامعتبر است.</div>
        <div *ngIf="formControls['email'].errors?.['maxlength']">ایمیل نباید بیشتر از ۱۰۰ کاراکتر باشد.</div>
         <!-- خطای سرور برای ایمیل -->
        <div *ngIf="formControls['email'].errors?.['serverError']">{{ formControls['email'].errors?.['serverError'] }}</div>
      </div>
    </div>

    <div class="form-group">
      <label for="message">پیام:</label>
      <textarea
        id="message"
        formControlName="message"
        rows="5"
        [class.is-invalid]="formControls['message'].invalid && (formControls['message'].touched || formControls['message'].dirty)"
      ></textarea>
      <div *ngIf="formControls['message'].invalid && (formControls['message'].touched || formControls['message'].dirty)" class="error-message">
        <div *ngIf="formControls['message'].errors?.['required']">پیام الزامی است.</div>
        <div *ngIf="formControls['message'].errors?.['maxlength']">پیام نباید بیشتر از ۵۰۰ کاراکتر باشد.</div>
         <!-- خطای سرور برای پیام -->
        <div *ngIf="formControls['message'].errors?.['serverError']">{{ formControls['message'].errors?.['serverError'] }}</div>
      </div>
    </div>

    <!-- نمایش پیام وضعیت ارسال -->
    <div *ngIf="submissionStatus === 'sending'" class="status-message sending">
      در حال ارسال...
    </div>
    <div *ngIf="submissionStatus === 'success'" class="status-message success">
      پیام شما با موفقیت ارسال شد!
    </div>
    <div *ngIf="submissionStatus === 'error'" class="status-message error">
      <!-- تغییر اینجا: serverErrors.general به serverErrors['general'] -->
      {{ serverErrors['general'] || 'خطا در ارسال پیام. لطفاً دوباره تلاش کنید.' }}
    </div>

    <div class="form-actions">
      <button type="submit" [disabled]="contactForm.invalid || submissionStatus === 'sending'">
        ارسال پیام
      </button>
    </div>
  </form>
</div>
